import React from 'react';

interface ScoreBadgeProps {
  score: number;
  size?: 'sm' | 'md';
}

const ScoreBadge: React.FC<ScoreBadgeProps> = ({ score, size = 'md' }) => {
  const getColorClass = (s: number): string => {
    if (s < 25) return 'score-red';
    if (s < 50) return 'score-orange';
    if (s < 75) return 'score-yellow';
    return 'score-green';
  };

  return (
    <span
      className={`score-badge ${getColorClass(score)}`}
      style={size === 'sm' ? { fontSize: '0.7rem', padding: '1px 8px' } : undefined}
    >
      {Math.round(score)}
    </span>
  );
};

export default ScoreBadge;
